import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { ELEMENT_HIGHLIGHT } from './defaults';
import { ColorDefinition, HighlightElementPluginOptions } from './types';

const HighlightElement = dynamicEditorComponent<{ color: ColorDefinition } & RenderElementProps>(
  () => import('./component/HighlightElement').then((mod) => mod.HighlightElement),
  {
    loading: ({ props }) => <span {...props?.attributes}>{props?.children}</span>,
  },
);

export const renderHighlightElement =
  (options: HighlightElementPluginOptions) =>
    ({ element, children, attributes }: RenderElementProps) => {
      const { colors } = options;
      if (element.type === ELEMENT_HIGHLIGHT && element.highlightKey) {
        const { highlightKey } = element;
        const color = colors.find((i) => i.key === highlightKey);
        if (color) {
          return (
          <HighlightElement color={color} element={element} attributes={attributes}>
            {children}
          </HighlightElement>
          );
        }
      }
      return null;
    };
